import { useCallback, useEffect, useRef, useState } from 'react';
import { installerApi } from '../utils/installerApi';

const HEARTBEAT_MS = 45000;
const KEY = 'installer_available';

export function useInstallerPresence(token) {
  const [online, setOnline] = useState(() => localStorage.getItem(KEY) === '1');
  const [geoError, setGeoError] = useState(null);
  const timer = useRef(null);

  const sendBeat = useCallback(() => {
    if (!token) return;
    if (!navigator.geolocation) { installerApi.presenceOnline(token, null, null).catch(() => {}); return; }
    navigator.geolocation.getCurrentPosition(
      (pos) => { setGeoError(null); installerApi.presenceOnline(token, pos.coords.latitude, pos.coords.longitude).catch(() => {}); },
      () => { setGeoError('denied'); installerApi.presenceOnline(token, null, null).catch(() => {}); },
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 30000 },
    );
  }, [token]);

  useEffect(() => {
    if (!online || !token) return undefined;
    sendBeat();
    timer.current = setInterval(sendBeat, HEARTBEAT_MS);
    return () => { if (timer.current) clearInterval(timer.current); };
  }, [online, token, sendBeat]);

  const goOnline = useCallback(() => { localStorage.setItem(KEY, '1'); setOnline(true); }, []);
  const goOffline = useCallback(() => {
    localStorage.removeItem(KEY);
    setOnline(false);
    if (token) installerApi.presenceOffline(token).catch(() => {});
  }, [token]);

  return { online, goOnline, goOffline, geoError };
}
